<template>
    <div class="Pay">
        <div class="Pay_header">
            <div class="OpenCard_header_title">
                <p>支付</p>
            </div>
        </div>
        <div class="Pay_content">
            <div class="Pay_content_price">
                <div class="Pay_content_price_logo">
                    <img src="~@/assets/images/pay/logo.png" alt="" />
                </div>
                <p>
                    需充值: <span>{{ sumFee }}</span>元
                </p>
            </div>

            <div class="Pay_content_mode">
                <p class="title">支付方式</p>
                <section class="selectPay">
                    <ul class="payBox active" id="payBox">
                        <li class="payWay" v-if="payKind == 1">
                            <div class="payWay_left">
                                <img src="../../assets/images/pay/wx1.png" />
                                <span>微信支付</span>
                            </div>
                            <span class="active"></span>
                            <!-- <span class="chooseIcon" :class="item.payType == payKind ? 'active' : ''"></span> -->
                        </li>
                        <li class="payWay" v-if="payKind == 2">
                            <div class="payWay_left">
                                <img src="../../assets/images/pay/zjczf.png" />
                                <span>资金池支付</span>
                            </div>
                            <span class="active"></span>
                        </li>
                    </ul>
                </section>
            </div>

            <div class="btn">
                <button @click="openPay">缴费</button>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, Dialog } from "vant"
import env from '../../common/newapi/env.js'
import preventBack from "vue-prevent-browser-back"
import OpenCardParamsMixin from '../../components/openCard/OpenCardParamsMixin.js'
import {
    QueryOpenCardLocation,
    AddOpenCardLocation,
    AliPay,
    WxPay,
    PayKind,
    FundPoolRecharge
} from "../../common/newapi/api.js"
export default {
    components: {},
    mixins: [preventBack, OpenCardParamsMixin], //注入  阻止返回上一页
    data() {
        return {
            // payList: [
            //     {
            //         text: "微信支付",
            //         tuimg: require("../../assets/images/pay/wx1.png"),
            //         payType: "1"
            //     },
            //     {
            //         text: "资金池支付",
            //         tuimg: require("../../assets/images/pay/zjczf.png"),
            //         payType: "2"
            //     },
            //     {
            //         text: "支付宝支付",
            //         tuimg: require("../../assets/images/pay/zfb1.png"),
            //     },
            // ],
            payIndex: "",
            AllformData: "",
            sumFee: "",
            payWay: "", //支付方式
            payFrontData: {}, //支付前缓存的数据
            Allouttradeno: "", //商户流水号
            payKind: "",//支付方式
            BackUrl: "", //支付的动态返回地址
        }
    },
    created() {
        this.paydata()
    },

    // 组件方法
    methods: {
        // 获取支付前的数据
        async paydata() {
            this.BackUrl = localStorage.getItem("PayBackUrl")
            var QueryOpenCardData = await QueryOpenCardLocation({
                uimId: localStorage.getItem("uimId"),
            })
            if (QueryOpenCardData.code != 1) {
                Dialog.alert({
                    message: "开卡时间过长数据缺失,请重新输入手机号",
                }).then(() => {
                    this.$router.push(this.BackUrl)
                })
            } else {
                this.payFrontData = QueryOpenCardData.data
                this.sumFee = QueryOpenCardData.data.sumFee
                // 获取支付方式
                var PayQuery = await PayKind({
                    phoneNumber: QueryOpenCardData.data.serviceId,
                })
                this.payKind = PayQuery.data.payKind
            }
        },

        async openPay() {
            // 常规支付：1及资金池支付：2
            if (this.payKind == 1) {
                // 常规支付
                // 获取微信支付链接接口
                var WxPayData = await WxPay({
                    phone: this.payFrontData.serviceId,
                    amount: `${this.payFrontData.sumFee}`,
                    recordNumber: this.payFrontData.recordNumber,
                })
                if (WxPayData.code == 1) {
                    this.Allouttradeno = WxPayData.outtradeno //拿到商户流水号
                    this.AllformData = WxPayData.form //拿到去支付页面的链接
                    this.AddRedis()
                }
                //code=2：已支付，无需再次支付
                else if (WxPayData.code == 2) {

                    this.payFrontData.rechargeFlag = "finish" // 充值标记赋值
                    this.payFrontData.outTradeNo = FundPoolRechargeData.data.outTradeNo // 商户流水号赋值
                    let params = this.getOpenCardLocationParams(this.payFrontData);
                    // 用户再次进入支付页面 点击缴费增加缓存记录返回开卡流程
                    let AddOpenCardOne = await AddOpenCardLocation({
                        ...params,
                        openCardLocation: "2", //步骤条进度
                    })

                    if (AddOpenCardOne.code != 1) {
                        Dialog.alert({
                            message: "开卡时间过长数据缺失,请重新输入手机号",
                        }).then(() => {
                            this.$router.push(this.BackUrl)
                        })
                    } else {
                        localStorage.setItem("payquery", "1")
                        this.$router.push(this.BackUrl)
                    }
                } else {
                    Toast({
                        position: "bottom",
                        message: WxPayData.msg,
                    })
                }
            } else if (this.payKind == 2) {
                // 资金池支付
                var FundPoolRechargeData = await FundPoolRecharge({
                    pay_fee: this.payFrontData.sumFee,//充值金额
                    work_no: this.payFrontData.acceptPerson,// 登录工号
                    service_id: this.payFrontData.serviceId,// 号码
                    dealer_id: this.payFrontData.dealerMainId,// 工号顶级渠道
                    recordNumber: this.payFrontData.recordNumber,//订单号
                })
                if (FundPoolRechargeData.code == 0) {
                    this.payFrontData.rechargeFlag = "finish" // 充值标记赋值
                    this.payFrontData.outTradeNo = FundPoolRechargeData.data.outTradeNo // 商户流水号赋值
                    let params = this.getOpenCardLocationParams(this.payFrontData);
                    // 资金池支付成功把之前的信息存redis
                    let AddOpenCardOne = await AddOpenCardLocation({
                        ...params,
                        openCardLocation: "2", //步骤条进度
                    })
                    if (AddOpenCardOne.code != 1) {
                        Dialog.alert({
                            message: "开卡时间过长数据缺失,请重新输入手机号",
                        }).then(() => {
                            this.$router.push(this.BackUrl)
                        })
                    } else {
                        localStorage.setItem("payquery", "1")
                        this.$router.push(this.BackUrl)
                    }
                } else {
                    Toast({
                        position: "bottom",
                        message: FundPoolRechargeData.message,
                    })
                }
            }
            // 获取支付宝支付链接接口
            // else {
            //     // 获取支付宝支付链接接口
            //     let AliPayData = await AliPay({
            //         phone: this.payFrontData.serviceId,
            //         amount: `${this.payFrontData.sumFee}.00`,
            //         recordNumber: this.payFrontData.recordNumber,
            //     })
            //     if (AliPayData.code != 1) {
            //         Toast({
            //             position: "bottom",
            //             message: AliPayData.msg,
            //         })
            //     } else {
            //         this.Allouttradeno = AliPayData.outtradeno //拿到商户流水号
            //         this.AllformData = AliPayData.form //拿到去支付页面的链接
            //         this.AddRedis()
            //     }
            // }
        },

        // 第一次保存支付相关缓存记录
        async AddRedis() {
            this.payFrontData.rechargeFlag = "start" // 充值标记赋值
            this.payFrontData.outTradeNo = this.Allouttradeno //商户流水号赋值
            let params = this.getOpenCardLocationParams(this.payFrontData);
            let AddOpenCardOnePay = await AddOpenCardLocation({
                ...params, //17个参数
                openCardLocation: "1", //步骤条进度
                prodOfferName: this.payFrontData.prodOfferName, //套餐名称
            })
            if (AddOpenCardOnePay.code != 1) {
                Dialog.alert({
                    message: "缓存记录失败,请重新进行开卡",
                }).then(() => {
                    this.$router.push(this.BackUrl)
                })
            } else {
                if (this.payWay == 0) {
                    // 拼接支付后的返回地址
                    let redirect_url = `${env.prod.baseUrl}/WxQuery`
                    let wxUrl =
                        this.AllformData +
                        "&redirect_url=" +
                        encodeURIComponent(redirect_url)
                    window.location.href = wxUrl
                }
                // 支付宝跳转支付页面
                // else {
                //     const div = document.createElement("div")
                //     div.innerHTML = this.AllformData
                //     document.body.appendChild(div)
                //     document.forms[0].submit()
                // }
            }
        },

        // 选择支付方式
        // addImg(index, item) {
        //     this.payWay = index
        //     let _this = this
        //     _this.isBlanced = !_this.isBlanced
        //     if (_this.payIndex == index) {
        //         if (!_this.isBlanced) {
        //             _this.payIndex = -1
        //         } else {
        //             _this.payIndex = index
        //         }
        //     } else {
        //         _this.payIndex = index
        //     }
        // },
    },

    computed: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
@import "../../assets/css/openCardScss/openCard.scss";
</style>